import React, { FC, useState, useEffect } from 'react'

type AlertPosition =
  | 'top-right'
  | 'top-left'
  | 'top-center'
  | 'bottom-right'
  | 'bottom-left'
  | 'bottom-center'

interface AlertProps {
  variant?: string
  autoClose?: number
  children: any
  showAlert: boolean
  setShowAlert: (show: boolean) => void
  position?: AlertPosition
  className?: string
}

const Alert: FC<AlertProps> = ({
  variant = 'primary',
  autoClose = 5000,
  children,
  showAlert,
  setShowAlert,
  position = 'top-right',
  className = '',
}) => {
  // const [show, setShow] = useState(true);

  useEffect(() => {
    const timeId = setTimeout(() => {
      // After 3 seconds set the show value to false
      setShowAlert(false)
    }, autoClose)

    return () => {
      clearTimeout(timeId)
    }
  }, [])

  if (!showAlert) {
    return null
  }

  const positionStyles = {
    'top-right': { top: '1rem', right: '1rem' },
    'top-left': { top: '1rem', left: '1rem' },
    'top-center': {
      top: '1rem',
      left: '50%',
      transform: 'translateX(-50%)',
    },
    'bottom-right': { bottom: '1rem', right: '1rem' },
    'bottom-left': { bottom: '1rem', left: '1rem' },
    'bottom-center': {
      bottom: '1rem',
      left: '50%',
      transform: 'translateX(-50%)',
    },
  }

  return (
    <div
      className={`alert alert-${variant} alert-dismissible ${className}`}
      role='alert'
      style={{
        position: 'fixed',
        maxWidth: '400px',
        width: '100%',
        zIndex: 1080,
        margin: '0.75rem',
        ...positionStyles[position],
      }}
    >
      {children}
      <button
        type='button'
        className='btn-close'
        onClick={() => setShowAlert(false)}
        aria-label='Close'
      ></button>
    </div>
  )
}

export default Alert
